module.exports = __webpack_public_path__ + "img/appicon.7a2f6342.svg";